<script>
/**
 * Descripción: Pantalla ApplicationInstance
 *
 * @displayName ApplicationInstance
 */
import httpService from '@/services/httpService.js';

import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';

import { mapActions } from 'vuex';

const ApplicationInstanceFilterViewComponent = () =>
  import(
    '@/views/ApplicationInstance/ApplicationInstanceFilterViewComponent.vue'
  );

export default {
  name: 'ApplicationInstanceViewComponent.vue',

  components: {
    ApplicationInstanceFilterViewComponent
  },

  created() {
    this.addNavbar(['Instancias']);
  },

  methods: {
    /**
     * Configuración NavBar
     */
    ...mapActions('navbar', ['addNavbar']),

    /**
     * Crear Nuevo Usuario
     */
    $_new() {
      // object
      this.$router.push({ name: 'ApplicationInstanceEditorViewComponent' });
    },

    /**
     * Editar Pantalla Editor
     */
    $_edit(params) {
      // object
      this.$router.push({
        name: 'ApplicationInstanceEditorViewComponent',
        params: { Id: params.selected['instanceId'] }
      });
    },

    /**
     * Eliminar Objecto
     */
    $_delete(params) {
      let object = BaseArrayHelper.SetObject({}, params[0]);
      httpService
        .post('ApplicationInstance/Delete', [object])
        .then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$refs.Grid.$_refresh();
          }
        });
    }
  }
};
</script>

<template>
  <div>
    <h3>
      Instancias
    </h3>
    <v-divider></v-divider>
    <ApplicationInstanceFilterViewComponent
      :fnNew="$_new"
      :fnEdit="$_edit"
      :fnDelete="$_delete"
      ref="Grid"
    />
  </div>
</template>
